<template>
  <section class="japanese">
    <h1>日本語</h1>
  </section>
</template>

<script>
export default {
  name: 'TheJapanese',
  metaInfo() {
    return {
      title: '日本語',
    };
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.japanese {
  margin-top: 30px;

  @include for-tablet {
    margin-top: 60px;
  }

  @include for-desktop {
    margin-top: 90px;
  }

  /deep/ .flex-container {
    margin: auto;

    @include for-tablet {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 650px;
    }

    @include for-desktop {
      max-width: 900px;
    }

    .other-link {
      @include for-tablet {
        flex-basis: 48%;
        margin-bottom: 10px;
      }

      @include for-desktop {
        flex-basis: 32%;
      }

      &__link {
        @include for-desktop {
          padding-left: 52px;
        }
      }
    }

    .other-link + .other-link {
      @include for-tablet {
        margin-top: 0;
      }
    }
  }
}
</style>
